export function renderMarkdown(text, theme = 'dark') {
  if (!text) return '';
  text = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

  const headingColor = '#D4A417';
  const boldColor = theme === 'light' ? '#1a1a1a' : '#e8eaf0';
  const bulletBorder = theme === 'light' ? '#d1d5db' : '#2e3548';
  const ruleColor = theme === 'light' ? '#e5e7eb' : '#252a38';

  return text
    .replace(/^### (.+)$/gm, `<h4 style="margin:8px 0 4px;font-size:13px;color:${headingColor}">$1</h4>`)
    .replace(/^## (.+)$/gm, `<h3 style="margin:10px 0 4px;font-size:14px;color:${headingColor}">$1</h3>`)
    .replace(/^# (.+)$/gm, `<h2 style="margin:12px 0 6px;font-size:15px;color:${headingColor}">$1</h2>`)
    .replace(/\*\*(.+?)\*\*/g, `<strong style="color:${boldColor}">$1</strong>`)
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
    .replace(/- \[ \] /g, '☐ ')
    .replace(/- \[x\] /g, '☑ ')
    .replace(/^- (.+)$/gm, `<div style="padding:2px 0 2px 12px;border-left:2px solid ${bulletBorder};margin:2px 0">$1</div>`)
    .replace(/^---$/gm, `<hr style="border:none;border-top:1px solid ${ruleColor};margin:8px 0"/>`)
    .replace(/\n/g, '<br/>');
}
